import { IS_PRODUCTION } from '../../constants/constants';

const url = `${window.location.protocol}//${window.location.hostname}/admin`

const httpBaseConfig = {
  // baseUrl: 'https://aidd.vivabiotech.com/admin',
  // baseUrl: 'http://192.168.31.161:9006',
  baseUrl: 'https://miniprogram.tj-handsome.com/admin-gateway',

  // port: !IS_PRODUCTION ? '9006' : '9006',//本地
  port: !IS_PRODUCTION ? '' : '',//生产

  // baseUrl:!IS_PRODUCTION? 'http://localhost:':'http://ip:',
  // port: !IS_PRODUCTION?'81':'9001',
  prefix: !IS_PRODUCTION ? '/api-service/' : '/api-service/',
  minioUrl: 'http://ip:9000',
  imgUrl: 'https://asymbucket.oss-cn-beijing.aliyuncs.com/asym/',//基本
  // imgUrl: 'http://192.168.31.152:9006/api-service/map_src/',//本地
  imgUrls: '/api-service/map_src/',
  // imgBaseUrl:baseUrl,
  // imgPort:port,
  imgPrefix: !IS_PRODUCTION ? '/assets/' : '/img/',
  microService: '',
  ossPicUrl: "https://tgyminiprogram.oss-cn-beijing.aliyuncs.com/base/",
  downloadUrl: "https://tgyminiprogram.oss-cn-beijing.aliyuncs.com/download/",
  templateUrl: "https://asymbucket.oss-cn-beijing.aliyuncs.com/product/template/"
}

export default httpBaseConfig
